import COS from '@tencent/new-cos-js-sdk-v5';
import {
  getSupportCompanyCosConfig,
  getSupportCompanyCosSts,
} from '../../../../api';
import { getFirstManageSite } from '../../../../lib';
import { wrapRequestArea } from '../../../../lib/http/lib';
import { IAPICommonCosConfigRes } from '../../../../model/api-modules';

const siteCosConfigCache: Record<string, IAPICommonCosConfigRes> = {};
const siteCosInstanceCache: Record<string, COS> = {};

const getCosInstance = (site: string) => {
  const siteCosInstance = siteCosInstanceCache[site];
  if (siteCosInstance) {
    return siteCosInstance;
  }
  const cosInstance = new COS({
    getAuthorization(options, callback) {
      wrapRequestArea(getSupportCompanyCosSts, site)
        .then((data) => {
          const { credentials } = data;
          if (!data || !credentials) {
            return console.log('error');
          }
          callback({
            TmpSecretId: credentials.tmpSecretId,
            TmpSecretKey: credentials.tmpSecretKey,
            SecurityToken: credentials.sessionToken,
            // 建议返回服务器时间作为签名的开始时间，避免用户浏览器本地时间偏差过大导致签名错误
            StartTime: data.startTime, // 时间戳，单位秒，如：1580000000
            ExpiredTime: data.expiredTime, // 时间戳，单位秒，如：1580000000
          });
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    },
  });
  siteCosInstanceCache[site] = cosInstance;
  return cosInstance;
};

const getCosConfig = async (site: string) => {
  if (siteCosConfigCache[site]) {
    return siteCosConfigCache[site];
  }
  const config = await wrapRequestArea(getSupportCompanyCosConfig, site);
  if (config) {
    siteCosConfigCache[site] = config;
  }
  return config;
};

export const getSupportCompanyFileUrl = async (
  fileName?: string,
  propsSite?: string
) => {
  const site = propsSite || getFirstManageSite();
  const companyCOS = getCosInstance(site);
  const cosConfig = await getCosConfig(site);
  if (!fileName || !cosConfig) {
    return '';
  }
  const fileKey = `${cosConfig.uploadDir}${fileName}`;

  const uploadParams = {
    Bucket: cosConfig.bucket,
    Region: cosConfig.region,
    Key: fileKey,
  };
  const url = await new Promise<string>((resolve, reject) => {
    companyCOS.getObjectUrl(uploadParams, (err, data) => {
      if (err) {
        reject(err);
      }
      resolve(data.Url);
    });
  });
  return url;
};
